import styled from 'styled-components';

import { FontWeight, Color, Media, Spacing, Grid } from '../../theme';

export const Container = styled.div`
  background-color: ${Color.secondary};
`;

export const InnerContainer = styled.div`
  display: flex;
  padding: 150px ${Spacing.DesktopWide} 180px;
  max-width: calc(${Grid.DesktopWide} - 2 * ${Spacing.DesktopWide});
  margin: 0 auto;
  & > + & > {
    margin-left: 140px;
  }
  ${Media.desktop`
    flex-direction: column;
    padding: 150px ${Spacing.Desktop} 180px;
  `}
  ${Media.tablet`
    padding: 100px ${Spacing.Tablet} 180px;
  `}
`;

export const HeaderContainer = styled.div`
  margin-right: 140px;
  max-width: 680px;
  ${Media.desktop`
    max-width: none;
    width: 100%;
    margin: 0;
  `}
`;

export const InnerHeaderContainer = styled.div`
  overflow: hidden;
`;

export const SectionHeader = styled.h4`
  color: ${Color.darkGrey};
  font-size: 50px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0.2px;
  line-height: 65px;
  font-weight: 300;
  strong {
    color: ${Color.primary};
  }
  ${Media.tablet`
    font-size: 35px;
    letter-spacing: 0.14px;
    line-height: 46px;
  `}
`;

export const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 280px;
  ${Media.desktop`
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-top: 70px;
  `}
  ${Media.tablet`
    margin-top: 40px;
    flex-direction: column;
  `}
`;

export const Description = styled.p`
  color: ${Color.darkGrey};
  font-size: 20px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 36px;
  max-width: 450px;
  ${Media.desktop`
    margin-left: 50px;
  `}
  ${Media.tablet`
    margin-left: 0;
    margin-bottom: 40px;
  `}
`;

export const PromotionImage = styled.img`
  height: 138px;
  width: 138px;
  margin-top: 60px;
  ${Media.desktop`
    margin-top: 0;
  `}
`;
